import type { ReactElement } from 'react';

import Head from 'next/head';

import { Environments } from '../../../utilities/constants';
import { isTagGatewayEnabled } from '../../../utilities/constants/googleAnalytics';
import { useStaticContext } from '../../../utilities/context/static/StaticContext';

export const GALink = (): ReactElement => {
  const { configuration } = useStaticContext();
  const environment = Environments[process.env.ENVIRONMENT as keyof typeof Environments];

  // With the Google Tag Gateway enabled, GA4 hits are routed through our own origin (see GTM.tsx),
  // so preconnecting to google-analytics.com is pointless.
  if (environment && isTagGatewayEnabled(configuration.enableCLTAnalytics, environment)) {
    return <></>;
  }

  return (
    <Head>
      <link rel="preconnect" href="https://www.google-analytics.com" crossOrigin="" />
    </Head>
  );
};
